import { type ReactNode, useMemo, useState } from 'react';
import { App as AntdContext, ConfigProvider, theme } from 'antd';

import { defaultTheme } from './DefaultTheme.ts';
import { type ThemeColorSchemeType, ThemeContext } from './ThemeContext.ts';

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [themeColorScheme, setThemeColorScheme] =
    useState<ThemeColorSchemeType>('light');
  const darkMode = useMemo(
    () => themeColorScheme === 'dark',
    [themeColorScheme]
  );

  const changeThemeColorScheme = (scheme: ThemeColorSchemeType) => {
    localStorage.setItem('colorScheme', scheme);
    setThemeColorScheme(scheme);
  };

  /* Implement when dark mode is deployed
  useEffect(() => {
    const colorScheme = localStorage.getItem('colorScheme');
    if ((colorScheme && colorScheme === 'light') || colorScheme === 'dark') {
      setThemeColorScheme(colorScheme);
    } else {
      const { matches: systemDarkMode } = window.matchMedia(
        '(prefers-color-scheme:dark)'
      );
      const systemColorScheme = systemDarkMode ? 'dark' : 'light';
      setThemeColorScheme(systemColorScheme);
      localStorage.setItem('colorScheme', systemColorScheme);
    }
  }, []);
  */

  return (
    <ThemeContext.Provider
      value={{ darkMode, themeColorScheme, changeThemeColorScheme }}
    >
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm, // Change to `darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm` when dark mode is implemented
        }}
      >
        <ConfigProvider theme={defaultTheme(false)}>
          <AntdContext>{children}</AntdContext>
        </ConfigProvider>
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
